module.exports = __webpack_public_path__ + "static/media/whatsup.e471c5ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/icons/whatsup.svg
// module id = 1626
// module chunks = 0